export function getWrapperClassname() {
  return 'dapp-core-ui-wrapper';
}
